import { render, staticRenderFns } from "./ForgotEmail.vue?vue&type=template&id=70a67032&"
import script from "./ForgotEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotEmail.vue?vue&type=style&index=0&id=70a67032&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports